import { render, staticRenderFns } from "./JobProfileCard.vue?vue&type=template&id=0f4bc2c0&scoped=true&"
import script from "./JobProfileCard.vue?vue&type=script&lang=js&"
export * from "./JobProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./JobProfileCard.vue?vue&type=style&index=0&id=0f4bc2c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4bc2c0",
  null
  
)

export default component.exports